export default __webpack_public_path__ + "static/media/wallet-card-theme8.54fdd326.svg";